var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAuthorized('PROPOSE_ADD'))?_c('proposta-create',{ref:"propostaCreate",attrs:{"proposeDb":_vm.propose,"proposeConfigDb":_vm.propose.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }